import { Controller } from "@hotwired/stimulus"

const LIT_CLASS = { available: "roster-cell-candidate-available", warning: "roster-cell-candidate-warning" }
const TARGET_CLASS = "roster-cell--open-target"

// Dayparts (1..3) a grid cell covers: "2" is row 2, "1 / 3" rows 1 and 2.
function coversPeriod(cell, periods) {
  const start = parseInt(cell.style.gridRowStart, 10)
  const end = parseInt(cell.style.gridRowEnd, 10) || start + 1
  return periods.some(period => period >= start && period < end)
}

export default class extends Controller {
  static targets = ["panel"]
  static values = { date: String, slot: String, candidates: Object, periods: Array }

  connect() {
    if (!this.hasDateValue) return
    this.lit = []
    this.showTarget()
    Object.entries(this.candidatesValue).forEach(([status, ids]) => {
      ids.forEach(id => {
        document.querySelectorAll(`.roster-row[data-staff-member-id="${id}"] [data-cell-date="${this.dateValue}"]`).forEach(cell => {
          cell.classList.add(LIT_CLASS[status])
          this.lit.push([cell, LIT_CLASS[status]])
        })
      })
    })
    this.onOutsideClick = this.outsideClick.bind(this)
    document.addEventListener("click", this.onOutsideClick, true)
  }

  // Where the open activity would come: its date and dayparts for every colleague, tinted red over what is planned there.
  showTarget() {
    document.querySelectorAll(`.roster-cell[data-cell-date="${this.dateValue}"]`).forEach(cell => {
      if (!coversPeriod(cell, this.periodsValue)) return
      cell.classList.add(TARGET_CLASS)
      this.lit.push([cell, TARGET_CLASS])
    })
  }

  disconnect() {
    if (!this.lit) return
    this.lit.forEach(([cell, klass]) => cell.classList.remove(klass))
    document.removeEventListener("click", this.onOutsideClick, true)
    this.lit = null
  }

  outsideClick(event) {
    if (this.panelTarget.contains(event.target)) return

    const chip = event.target.closest("[data-open-slot-chip]")
    if (chip && chip.dataset.openSlotChip === this.slotValue) {
      event.preventDefault()
      event.stopPropagation()
    }
    this.close()
  }

  open(event) {
    event.preventDefault()
    event.stopPropagation()
    const url = event.currentTarget.dataset.activityPickerUrl
    if (!url) return

    const frame = document.getElementById("activity_picker_modal")
    if (frame) frame.src = url
  }

  close() {
    const frame = document.getElementById("activity_picker_modal")
    if (frame) {
      frame.removeAttribute("src")
      frame.innerHTML = ""
    }
  }

  closeBackground(event) {
    if (event.target === event.currentTarget) this.close()
  }

  stop(event) {
    event.stopPropagation()
  }
}
